import axios from 'axios'

const baseURL = process.env.VUE_APP_INTEGRATION_API;
const apiVersion =  process.env.VUE_APP_API_VERSION ? `/${process.env.VUE_APP_API_VERSION}` : '';

axios.defaults.withCredentials = true

let client = axios.create({
  baseURL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
       withCredentials: true,
       crossDomain: true
   }
})


export default {
  async decryptVal(encryptedData)
  {
    try{
        let data = "\"" + decodeURI(encryptedData) + "\"";

        return await client.post(`/registration${apiVersion}/integration/purpleAi`, data).then((response)=>{

            if(response.status === 200)
            {
                return response.data;
            }
            else
            {
              return -1;
            }
        
      });
    }
    catch (error) {
      console.log(error);
      throw(error);
    }
  },

}